import icon from "../../assets/antenna.svg";
import type { Property } from "../../types";

export const externalAntennaSupport: Property = {
  id: "externalAntennaSupport",
  title: "externalAntennaSupport.title",
  icon,
};
